import { Injectable } from '@angular/core';
import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { errorHandl } from 'src/app/utils/network-utils';
import { PlacementAuthService } from '../placement-auth-service/placement-auth.service';

@Injectable({
  providedIn: 'root'
})
export class ProposalService {
  private http: HttpClient;

  constructor(private handler: HttpBackend, private placementAuthService: PlacementAuthService) {
    this.http = new HttpClient(handler);
  }

  getProposalDetails(proposalId: number | string): Observable<any> {
    return this.placementAuthService.login().pipe(
      switchMap(token => {
        const headers = new HttpHeaders({
          'Authorization': `Bearer ${token}`
        });
        return this.http.get<any>(`${this.placementAuthService.baseUrl}/proposals/${proposalId}`, { headers });
      }),
      catchError(errorHandl)
    );
  }

  verifiedAccept(proposalId: number | string, facilityId: string | number, notes: string): Observable<any> {
    return this.placementAuthService.login().pipe(
      switchMap(token => {
        const headers = new HttpHeaders({
          'Authorization': `Bearer ${token}`
        });
        return this.http.post<any>(
          `${this.placementAuthService.baseUrl}/proposals/${proposalId}/verified_accept`,
          { facility_id: facilityId, notes },
          { headers }
        );
      }),
      catchError(errorHandl)
    );
  }

  decline(proposalId: number | string, facilityId: string | number, notes: string): Observable<any> {
    return this.placementAuthService.login().pipe(
      switchMap(token => {
        const headers = new HttpHeaders({
          'Authorization': `Bearer ${token}`
        });
        return this.http.post<any>(
          `${this.placementAuthService.baseUrl}/proposals/${proposalId}/decline`,
          { facility_id: facilityId, notes },
          { headers }
        );
      }),
      catchError(errorHandl)
    );
  }
}
